import { render } from "./Myaccount.vue?vue&type=template&id=3af821b0"
import script from "./Myaccount.vue?vue&type=script&lang=js"
export * from "./Myaccount.vue?vue&type=script&lang=js"
script.render = render

export default script